export default function BasicInfoStep({ formData, setFormData }) {

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  return (
    <div className="space-y-8">

      {/* TITLE */}
      <div>
        <h2 className="text-2xl font-semibold">
          Informations de base
        </h2>
        <p className="text-gray-500 mt-1">
          Renseignez les informations principales de votre établissement
        </p>
      </div>

      {/* FORM */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

        {/* NAME */}
        <div className="md:col-span-2">
          <label className="block mb-2 text-sm font-medium">
            Nom de l'établissement
          </label>
          <input
            name="name"
            placeholder="Ex: Hôtel Le Moroni Palace"
            value={formData.name}
            onChange={handleChange}
            className="w-full rounded-xl border border-gray-300 px-4 py-3 
                       focus:ring-2 focus:ring-green-500 focus:outline-none transition"
          />
        </div>

        {/* TYPE */}
        <div>
          <label className="block mb-2 text-sm font-medium">
            Type d’établissement
          </label>
          <select
            name="type"
            value={formData.type}
            onChange={handleChange}
            className="w-full rounded-xl border border-gray-300 px-4 py-3 
                       focus:ring-2 focus:ring-green-500 focus:outline-none transition"
          >
            <option value="">Sélectionner un type</option>
            <option value="hotel">Hôtel</option>
            <option value="chambre_hote">Chambre d’hôte</option>
            <option value="appartement_studio">Appartement / Studio</option>
          </select>
        </div>

        {/* ISLAND */}
        <div>
          <label className="block mb-2 text-sm font-medium">
            Île
          </label>
          <select
            name="island"
            value={formData.island}
            onChange={handleChange}
            className="w-full rounded-xl border border-gray-300 px-4 py-3 
                       focus:ring-2 focus:ring-green-500 focus:outline-none transition"
          >
            <option value="">Sélectionner une île</option>
            <option value="Ngazidja">Ngazidja</option>
            <option value="Anjouan">Anjouan</option>
            <option value="Moheli">Mohéli</option>
          </select>
        </div>

        {/* CITY */}
        <div>
          <label className="block mb-2 text-sm font-medium">
            Ville
          </label>
          <input
            name="city"
            placeholder="Ex: Moroni"
            value={formData.city}
            onChange={handleChange}
            className="w-full rounded-xl border border-gray-300 px-4 py-3 
                       focus:ring-2 focus:ring-green-500 focus:outline-none transition"
          />
        </div>

        {/* ADDRESS */}
        <div>
          <label className="block mb-2 text-sm font-medium">
            Adresse
          </label>
          <input
            name="adress"
            placeholder="Ex: Rue de la Corniche"
            value={formData.adress}
            onChange={handleChange}
            className="w-full rounded-xl border border-gray-300 px-4 py-3 
                       focus:ring-2 focus:ring-green-500 focus:outline-none transition"
          />
        </div>

        {/* DESCRIPTION */}
        <div className="md:col-span-2">
          <label className="block mb-2 text-sm font-medium">
            Description
          </label>
          <textarea
            name="desc"
            rows={4}
            placeholder="Décrivez votre établissement (ambiance, services, localisation...)"
            value={formData.desc}
            onChange={handleChange}
            className="w-full rounded-xl border border-gray-300 px-4 py-3 
                       focus:ring-2 focus:ring-green-500 focus:outline-none transition resize-none"
          />
        </div>

      </div>

    </div>
  );
}